import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import img1 from "../img/follow.svg";
import Footer from "../components/Footer";
import Logout from "../components/Logout";
import {
  useGetDashboardDataQuery,
  useGetListViewQuery,
  useGetUsersQuery,
} from "../redux/api/DashboardApi";
import { Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Loader from "../components/Loader";
import { usePendingLeadQuery } from "../redux/api/LeadApi";
import "react-big-calendar/lib/css/react-big-calendar.css";

const TeamDashboard = () => {
  const [addClass, setAddClass] = useState("");
  const [addSideClass, setSideAddClass] = useState("");
  const [showLogout, setShowLogout] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  let id = userData?.data?.id;

  // API Calling
  const { data: profiledata } = useGetUsersQuery();
  const { data } = useGetDashboardDataQuery(id);
  const { data: listview, isLoading } = useGetListViewQuery(id);
  const { data: pendingLead } = usePendingLeadQuery(id);

  const dateFormat = (inputDate) => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const formattedDate = `${day < 10 ? "0" : ""}${day}-${
      month < 10 ? "0" : ""
    }${month}-${year}`;
    return formattedDate;
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Filtered Pendinglead table data in Accending order
  const sortedLeads = pendingLead?.leadid
    ?.slice(0, 10)
    .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

  const gettoday = new Date();
  const todayDate =
    gettoday.getDate() +
    "-" +
    (gettoday.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    gettoday.getFullYear();
  return (
    <>
      <div className="position-absolute  top-0  w-100 z-0"></div>
      <Sidebar addSideClass={addSideClass} />
      <div className={`dashnoard ${addClass}`}>
        <Navbar
          setShowLogout={setShowLogout}
          setSideAddClass={setSideAddClass}
          setAddClass={setAddClass}
          addClass={addClass}
          addSideClass={addSideClass}
          profiledata={profiledata}
        />
        <div className="brightness container mt-4 ">
          <div className="row justify-content-lg-center  justify-content-md-center  justify-content-start  gy-3">
            <div className=" col-4 px-2 px-md-4">
              <Link to={`/followup?currentData=${todayDate}`}>
                <div
                  className="card border-0  w-100 d-flex  flex-column justify-content-between  "
                  id="color-card-one"
                >
                  <img src={img1} alt="..." />
                  <h5 className=" text-center text-white fs-3">
                    {data?.data?.todayfollowup}
                  </h5>
                  <p className=" fw-medium text-white text-center ">
                    Today's Followup
                  </p>
                </div>
              </Link>
            </div>
            <div className="  col-4 px-2 px-md-4">
              <Link to={`/lead?currentData=${todayDate}`}>
                <div
                  className="card border-0 w-100 d-flex  flex-column justify-content-between"
                  id="color-card-two"
                >
                  <img src={img1} alt="..." />

                  <h5 className=" text-center text-white fs-3">
                    {data?.data?.todaylead}
                  </h5>
                  <p className=" fw-medium text-white text-center">
                    Today's Leads
                  </p>
                </div>
              </Link>
            </div>
            <div className="  col-4 px-2 px-md-4">
              <Link to={`/pending`}>
                <div
                  className="card border-0   w-100 d-flex  flex-column justify-content-between  "
                  id="color-card-one"
                  style={{
                    backgroundColor: "#EF4347",
                  }}
                >
                  <img
                    src={img1}
                    alt="..."
                    style={{ backgroundColor: "#f76c6c" }}
                  />
                  <h5 className=" text-center text-white fs-3">
                    {pendingLead?.data}
                  </h5>
                  <p className=" fw-medium text-white  text-center ">
                    Pending Follow Up
                  </p>
                </div>
              </Link>
            </div>
            <div className="col-4 px-2 px-md-4">
              <Link to={`/lead?status=${11}`}>
                <div
                  className="card border-0 w-100 d-flex  flex-column justify-content-between"
                  id="color-card-three"
                >
                  <img src={img1} alt="..." />

                  <h5 className=" text-center text-white fs-3">
                    {data?.data?.totalconnected}
                  </h5>
                  <p className=" fw-medium text-white  text-center ">
                    Total Contacted
                  </p>
                </div>
              </Link>
            </div>
            <div className="  col-4 px-2 px-md-4">
              <Link to={`/lead?status=${15}`}>
                <div
                  className="card border-0 w-100 d-flex  flex-column justify-content-between"
                  id="color-card-four"
                >
                  <img src={img1} alt="..." />

                  <h5 className=" text-center text-white fs-3">
                    {data?.data?.totalvisit}
                  </h5>
                  <p className=" fw-medium text-white  text-center">
                    Total Visit Done
                  </p>
                </div>
              </Link>
            </div>

            <div className="  col-4 px-2 px-md-4">
              <Link to={`/lead?status=${16}`}>
                <div
                  className="card border-0  w-100 d-flex  flex-column justify-content-between  "
                  id="color-card-one"
                  style={{
                    backgroundColor: "#25d366",
                  }}
                >
                  <img src={img1} alt="..." className=" bg-success " />
                  <h5 className=" text-center text-white fs-3">
                    {data?.data?.totalclosed}
                  </h5>
                  <p className=" fw-medium text-white  text-center ">Closed</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="container mt-5">
          <div className="row gy-2">
            <div className="col-md-12">
              <h5>Team</h5>

              <div className="tab-content" id="pills-tabContent">
                <table className="table dash-table  table-borderless w-100  overflow-x-auto ">
                  <thead>
                    <tr id="table-heading">
                      <th
                        scope="col"
                        className="fixed-column sticky-col first-col"
                      >
                        S.No
                      </th>
                      <th
                        scope="col"
                        className="fixed-column sticky-col second-col"
                      >
                        Name
                      </th>
                      <th scope="col">Mobile</th>
                      <th>Email</th>

                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody className="vertical-border text-center ">
                    {/* </tbody> {isLoading ? (
                      <tr className="w-100 bg-white ">
                        <td></td>
                        <td></td>
                        <td></td>
                        <Loader />
                        <td></td>
                        <td></td>
                      </tr>
                    ) : (
                     listview  &&
                     listview?.data
                              .filter((result) => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                const resDate = new Date(result.date);
                                resDate.setHours(0, 0, 0, 0); 
                                return resDate >= today; 
                              })
                              .slice(0, 10)
                              .sort((a, b) => {
                                const dateA = new Date(a.date);
                                const dateB = new Date(b.date);
                                return dateA - dateB 
                              })

                              .map((result, index) => {
                        return ( */}
                    <tr id="table-data">
                      <td className="sticky-col first-col ">{1}</td>
                      <td className="text-capitalize sticky-col second-col">
                        Name
                      </td>
                      <td className="text-capitalize">999999999</td>

                      <td className="date-create">dummy@gmail.com</td>

                      <td>
                        {/* <Link to={`/managelead/${result?.id}`}> */}
                        <i className="bi bi-eye-fill eye-icon mx-3 mx-md-0"></i>
                        {/* </Link> */}
                      </td>
                    </tr>
                    {/* );
                      })
                    )} */}
                    {/* {!isLoading &&  listview?.data?.length <= 0 && (
                      <tr>
                        <td></td>
                        <td></td>

                        <td>No Record Found</td>
                        <td></td>
                        <td></td>
                      </tr>
                    )} */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {showLogout && <Logout setShowLogout={setShowLogout} />}
    </>
  );
};

export default TeamDashboard;
